module.exports = __webpack_public_path__ + "img/Icon-76@2x.db8849b3.png";